/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Selection_First_LabelInputs */



/**
* | output |
* | --- |
* | "First Event" |
*
* @param {Audio_Description_Export_Selection_First_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_selection_first_label = /** @type {((inputs?: Audio_Description_Export_Selection_First_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Selection_First_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Premier événement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erste Veranstaltung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Primo evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Первое событие")
	if (locale === "es") return /** @type {LocalizedString} */ ("Primer evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("首场活动")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最初のイベント")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पहला आयोजन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Primeiro evento")
	return /** @type {LocalizedString} */ ("First Event")
});